/* The WorkRoom — Visual Search wiring
   -----------------------------------
   Lives as a THEME ASSET (Shopify never strips theme files, unlike the
   page-body editor). Loaded site-wide via theme.liquid, but it no-ops on
   any page that doesn't contain the visual-search markup, so it's safe
   everywhere. Targets the existing #vs-* elements already in the
   /pages/visualsearch page body.

   API endpoint unchanged: https://workroom-imagesearch-api.fly.dev
*/
(function () {
  var API = "https://workroom-imagesearch-api.fly.dev";
  var statusEl = document.getElementById("vs-status");
  var gridEl = document.getElementById("vs-grid");
  if (!statusEl || !gridEl) return; // not the visual-search page — do nothing

  function on(id, evt, fn) {
    var el = document.getElementById(id);
    if (el) el.addEventListener(evt, fn);
    return el;
  }

  function setStatus(msg, isErr) {
    statusEl.textContent = msg || "";
    statusEl.className = "vs-status" + (isErr ? " err" : "");
  }

  function search(body) {
    setStatus("Searching… the first search can take up to ~30 seconds while the server wakes up.");
    gridEl.innerHTML = "";
    var t0 = performance.now();
    fetch(API + "/storefront-search", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) {
        return res.text().then(function (txt) {
          setStatus("Error " + res.status + ": " + txt, true);
        });
      }
      return res.json().then(function (data) {
        var ms = Math.round(performance.now() - t0);
        var n = (data.results || []).length;
        setStatus(n ? (n + " matches · " + ms + " ms") : "No matches found.");
        render(data.results || []);
      });
    }).catch(function (e) {
      setStatus("Error: " + e.message, true);
    });
  }

  function render(results) {
    gridEl.innerHTML = "";
    for (var i = 0; i < results.length; i++) {
      var r = results[i];
      var a = document.createElement("a");
      a.className = "vs-card";
      a.href = r.handle ? "/products/" + r.handle : "#";
      a.innerHTML =
        '<img src="' + (r.imageUrl || "") + '" alt="" loading="lazy" />' +
        '<div class="vs-meta"><div class="vs-title">' +
        (r.title || "").replace(/</g, "&lt;") +
        '</div></div>';
      gridEl.appendChild(a);
    }
  }

  on("vs-urlBtn", "click", function () {
    var el = document.getElementById("vs-urlInput");
    var u = el ? el.value.trim() : "";
    if (u) search({ imageUrl: u });
  });
  on("vs-textBtn", "click", function () {
    var el = document.getElementById("vs-textInput");
    var t = el ? el.value.trim() : "";
    if (t) search({ text: t });
  });
  on("vs-textInput", "keydown", function (e) {
    if (e.key === "Enter") { var b = document.getElementById("vs-textBtn"); if (b) b.click(); }
  });
  on("vs-urlInput", "keydown", function (e) {
    if (e.key === "Enter") { var b = document.getElementById("vs-urlBtn"); if (b) b.click(); }
  });

  var drop = document.getElementById("vs-drop");
  var fileInput = document.getElementById("vs-file");
  var preview = document.getElementById("vs-preview");
  var previewImg = document.getElementById("vs-previewImg");
  var previewName = document.getElementById("vs-previewName");
  var previewSize = document.getElementById("vs-previewSize");
  var currentDataUri = null;

  if (drop && fileInput) {
    drop.addEventListener("click", function () { fileInput.click(); });
    drop.addEventListener("dragover", function (e) { e.preventDefault(); drop.classList.add("over"); });
    drop.addEventListener("dragleave", function () { drop.classList.remove("over"); });
    drop.addEventListener("drop", function (e) {
      e.preventDefault();
      drop.classList.remove("over");
      if (e.dataTransfer.files[0]) handleFile(e.dataTransfer.files[0]);
    });
    fileInput.addEventListener("change", function () {
      if (fileInput.files[0]) handleFile(fileInput.files[0]);
    });
  }

  function handleFile(f) {
    if (f.type.indexOf("image/") !== 0) { setStatus("Please choose an image file.", true); return; }
    if (f.size > 5 * 1024 * 1024) { setStatus("Image too large (>5 MB).", true); return; }
    var reader = new FileReader();
    reader.onload = function () {
      currentDataUri = reader.result;
      if (previewImg) previewImg.src = currentDataUri;
      if (previewName) previewName.textContent = f.name;
      if (previewSize) previewSize.textContent = (f.size / 1024).toFixed(0) + " KB · " + f.type;
      if (preview) preview.style.display = "flex";
      setStatus("");
    };
    reader.readAsDataURL(f);
  }

  on("vs-uploadBtn", "click", function () {
    if (currentDataUri) search({ imageData: currentDataUri });
  });
  on("vs-clearBtn", "click", function () {
    currentDataUri = null;
    if (preview) preview.style.display = "none";
    if (fileInput) fileInput.value = "";
  });

  // Optional AI decorator entry — only wires up if the button exists.
  on("vs-decoratorBtn", "click", function () {
    if (window.WRDecoratorQuiz && typeof window.WRDecoratorQuiz.open === "function") {
      window.WRDecoratorQuiz.open();
    } else {
      setStatus("Decorator quiz is not available right now. Please refresh and try again.", true);
    }
  });
})();